import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './CgCheckbox.module.scss'

interface CgCheckboxProps {
  value: boolean
  onChange(checked: boolean): void
  id?: string
}

const CgCheckbox: React.FC<CgCheckboxProps> = ({ value, onChange, id = '' }) => {
  return (
    <>
      <div className={styles.container}>
        <input
          type='checkbox'
          id={id}
          checked={value}
          onChange={(v) => onChange(v.target.checked)}
        />
        <label className={styles.square} htmlFor={id}>
          <StaticImage
            className={styles.tick}
            width={15}
            height={15}
            alt='✔️'
            src='./assets/img_tick.png'
          />
        </label>
      </div>
    </>
  )
}

export default CgCheckbox
